<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="row mx-0 mb-24 u-flex--vertical-end">
            <div class="col-12 col-md px-0 mb-18 mb-0@md">
                <h2 class="u-text-normal mb-12">Passwort ändern</h2>
            </div>

            <div class="col-12 p-0">
                <p v-if="error" class="text-error">{{ error }}</p>
                <form @submit.prevent="onSubmit">
                    <div class="form-group mr-12">
                        <label for="newPassword">Neues Passwort <sup>*</sup></label>
                        <input
                            v-model="form.newPassword"
                            class="form-control"
                            id="newPassword"
                            type="password"
                            autocomplete="new-password"
                            required
                        />
                    </div>

                    <div class="form-group mr-12">
                        <label for="repeatPassword">Neues Passwort wiederholen <sup>*</sup></label>
                        <input
                            v-model="form.repeatPassword"
                            class="form-control"
                            id="repeatPassword"
                            type="password"
                            autocomplete="new-password"
                            required
                        />
                    </div>

                    <app-button type="submit" :is-loading="isLoading">Speichern</app-button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/ui/Button.vue'


export default {
    name: 'PasswordReset',

    components: { AppButton },

    data: () => ({
        isLoading: false,
        error: '',
        form: {
            newPassword: '',
            repeatPassword: '',
        },
    }),

    methods: {
        validateForm () {
            this.error = ''

            if (!this.form.newPassword || !this.form.repeatPassword) {
                this.error = 'Bitte fülle alle Felder aus.'
                return
            }

            if (this.form.newPassword !== this.form.repeatPassword) {
                this.error = 'Die neuen Passwörter stimmen nicht überein.'
            }
        },

        async onSubmit () {
            if (this.isLoading) return

            this.validateForm()
            if (this.error) return

            this.isLoading = true

            try {
                const response = await this.$http.post('/reset-password', this.form)
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$toast.open({ type: 'success', message: response.data.successHtml })
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoading = false
            }
        },
    },
}
</script>
